import { render, staticRenderFns } from "./RemMenuElement.vue?vue&type=template&id=264cb3ae&"
import script from "./RemMenuElement.vue?vue&type=script&lang=js&"
export * from "./RemMenuElement.vue?vue&type=script&lang=js&"
import style0 from "./RemMenuElement.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports